/**
 * Assorted path utility functions.
 *
 * @module 00-utilities/path-utils.js
 * @version 2.0.0
 *
 * @author <Enzo de Villareal> [enzo.devillareal@selectra.info}
 * @author <Sergio Jiménez Herena> [sergio.jimenez@selectra.info]
 */


/**
 * An object created by Drupal to expose various info.
 *
 * @memberof window
 * @property {object} drupalSettings
 * @property {string} drupalSettings.contentPath
 *   Content module directory path ( Agrippa )
 * @property {string} drupalSettings.themePath
 *   Parent theme path.
 * @property {string} drupalSettings.activeThemePath
 *   Active sub-theme path.
 */


/**
 * Paths exposed on drupalSettings
 *
 * @typedef {object} paths
 * @property {string} drupalContentPath
 *   Content module directory path ( Agrippa )
 * @property {string} drupalBasePath
 *   Parent theme path.
 * @property {string} drupalActivePath
 *   Active sub-theme path.
 */


/**
 * Get paths
 *
 * @function
 * @returns {paths} paths
 */
export default function getDrupalPaths() {

  return {

    drupalContentPath:
      ( function getContentPath() {
        const hasContentPath =
          window.drupalSettings &&
          typeof window.drupalSettings.contentPath === 'string';
        return hasContentPath ?
          `/${ window.drupalSettings.contentPath }` : null;
      }()),

    drupalBasePath:
      ( function getBasePath() {
        const hasThemePath =
          window.drupalSettings &&
          typeof window.drupalSettings.themePath === 'string';
        return hasThemePath ?
          `/${ window.drupalSettings.themePath }` : null;
      }()),

    drupalActivePath:
      ( function getActivePath() {
        const hasActivePath =
          window.drupalSettings &&
          typeof window.drupalSettings.activeThemePath === 'string';
        return hasActivePath ?
          `/${ window.drupalSettings.activeThemePath }` : null;
      }()),

  };

}
